import { IApiError } from "../utils/api.interfaces";
import {
    isArgumentException,
    isArgumentNullException,
    isInvalidApiOperationException,
    isInvalidOperationException,
    isInvalidPermissionsException,
    isNotSupportedException,
    isRelationViolatedException
} from "../utils/errorHandler/error.types";

/**
 * True for a structured MyGeotab API error (carries the `data.type` envelope every classifier
 * keys off). False for an unexpected runtime fault (a bug, a null deref) that should surface
 * rather than be classified and retried.
 */
export function isApiError(error: unknown): error is IApiError {
    return typeof (error as IApiError)?.data?.type === "string";
}

/** Errors the server will keep rejecting — retrying is pointless, so the record is failed. */
export function isTerminalError(error: IApiError): boolean {
    return (
        isInvalidApiOperationException(error) ||
        isInvalidPermissionsException(error) ||
        isInvalidOperationException(error) ||
        isArgumentException(error) ||
        isArgumentNullException(error) ||
        isNotSupportedException(error) ||
        isRelationViolatedException(error)
    );
}
